import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORM } from 'utility-ts-orm';

import { IStudyGroupMembersDatasource } from '../datasources/study_group_members_datasource';
import { IStudyGroupMembersQueryResult } from '../study_group_interfaces';

export class StudyGroupMembersQuery implements IQuery {
  private _result: IStudyGroupMembersQueryResult;
  constructor(private ngStudyGroupMembersDatasource: IStudyGroupMembersDatasource, private accountModel: any) {
    ORM.registerQuery(this, ngStudyGroupMembersDatasource);
  }
  run() {
    const buddies = _4.toArray(this.ngStudyGroupMembersDatasource.read());
    _4.remove(buddies, (buddy: any) => buddy.email === this.accountModel.email);
    const selectedBuddiesCount = _4.size(_4.filter(buddies, '_isChecked'));
    const selectedBuddies = _4.filter(buddies, '_isChecked');
    const buddiesCount = _4.size(buddies);
    const isAllUsersSelected = selectedBuddiesCount === buddiesCount;
    const selectionLabelText = isAllUsersSelected ? 'Clear All' : 'Select All';

    this._result = {
      buddies,
      selectedBuddiesCount,
      selectedBuddies,
      buddiesCount,
      selectionLabelText,
      isAllUsersSelected
    };
    return this;
  }
  get result(): IStudyGroupMembersQueryResult {
    return this._result;
  }
}

angular.module('capability-ng-study-groups').service('ngStudyGroupMembersQuery', StudyGroupMembersQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/queries/study_group_members_query.ts